import { render, staticRenderFns } from "./SchoolSite.vue?vue&type=template&id=4ebe412f&scoped=true"
import script from "./SchoolSite.vue?vue&type=script&lang=js"
export * from "./SchoolSite.vue?vue&type=script&lang=js"
import style0 from "./SchoolSite.vue?vue&type=style&index=0&id=4ebe412f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebe412f",
  null
  
)

export default component.exports